
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 47 47","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M23.5 1C11.073 1 1 11.074 1 23.498 1 35.926 11.073 46 23.5 46S46 35.926 46 23.498C46 11.074 35.927 1 23.5 1z","fill":"#4FA2B7"}}),_c('svg',{attrs:{"viewBox":"0 0 28 28","fill":"#FFF","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M14 4L7 14l7 10 7-10M9.44 14L14 7.5l4.56 6.5L14 20.5"}})])])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/virtualFill.svg